import usePermissions from "@/hooks/usePermissions";
import { isBackendPending } from "@/config/backendPending";
import { NAV_GROUPS } from "@/components/layout/navConfig";
import type { PaletteItem, PaletteSource } from "@/components/layout/palette/paletteSources";

/** Every menu page the user may open — the sidebar's own two-axis visibility rule. */
export const pagesSource: PaletteSource = {
  id: "pages",
  heading: "Pages",
  minQueryLength: 0,
  useItems() {
    const { canAccessMenu } = usePermissions();
    const items: PaletteItem[] = NAV_GROUPS.flatMap((group) =>
      group.items
        .filter((item) => canAccessMenu(item.id) && !isBackendPending(item.id))
        .map((item) => ({
          id: item.id,
          label: item.label,
          hint: group.label ?? undefined,
          icon: item.icon,
          href: item.path,
        }))
    );
    return { items, isLoading: false };
  },
};
